import { render, staticRenderFns } from "./MandatsModelEdit.vue?vue&type=template&id=2bd84f90&"
import script from "./MandatsModelEdit.vue?vue&type=script&lang=js&"
export * from "./MandatsModelEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports